export const isDateInFuture = dateString => {
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) {
    return false;
  }
  return date.getTime() >= Date.now();
};